<template>
  <div class="project-select">
    <div class="middle flex">
      <div class="name flex column">
        <small>{{ account.account_type == 'MANAGER'? 'Administradora' : 'Projeto' }}</small>
        <small
          ><b>({{ account.id }}) {{ account.name  | protect }}</b></small
        >
      </div>
      <router-link v-if="hasMultipleAccounts" :to="{ name: 'Account' }">
        <div class="button secondary">
          <i class="fas fa-exchange-alt"></i>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ProjectSelector",
  props: ["hasMultipleAccounts"],
  data() {
    return {};
  },
  mounted() {
  },
  watch: {
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.project-select {
  padding-right: 12px;
  border-right: 1px solid var(--border);
  .name {
    margin-right: 12px;
  }
}
</style>